import { render, staticRenderFns } from "./StartInvitations.vue?vue&type=template&id=bc24a58c&scoped=true"
import script from "./StartInvitations.vue?vue&type=script&lang=js"
export * from "./StartInvitations.vue?vue&type=script&lang=js"
import style0 from "./StartInvitations.vue?vue&type=style&index=0&id=bc24a58c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc24a58c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDivider,VIcon})
